export class TerraError implements Error {
  name: string;
  message: string;

  constructor(message: string) {
    this.name = '';
    this.message = message;
  }
}

export class TrackingAppIsPending extends TerraError {
  constructor() {
    super('Tracking app is pending');
  }
}

export class TrackingMismatchPlatform extends TerraError {
  constructor() {
    super('Tracking App platform and Terra app platform are not match');
  }
}

export class TrackingPermissionDenied extends TerraError {
  constructor() {
    super('Permission denied');
  }
}

export class TrackingAppIdNotFoundError extends TerraError {
  constructor() {
    super('Tracking app ID is not found');
  }
}

export class IamClientIdNotFoundError extends TerraError {
  constructor() {
    super('Login Client ID is not found');
  }
}

export class CannotFindCreatedTrackingApp extends TerraError {
  constructor() {
    super('Cannot found created tracking app');
  }
}

export class PaymentMerchantCodeNotFoundError extends TerraError {
  constructor() {
    super('Payment merchant code is not found');
  }
}

export class PaymentTerminalCodeNotFoundError extends TerraError {
  constructor() {
    super('Payment terminal code is not found');
  }
}

export class NotificationAppIdNotFound extends TerraError {
  constructor() {
    super('Notification App ID is not found');
  }
}

export class LoyaltyMissingLoginConfigError extends TerraError {
  constructor() {
    super('Login config is required before setting up loyalty config');
  }
}

export class LoyaltyInvalidClientIdError extends TerraError {
  constructor() {
    super('Loyalty client id is invalid');
  }
}

export class LoyaltyPermissionDenied extends TerraError {
  constructor() {
    super('Permission denied');
  }
}

export class LoyaltyClientIdNotFoundError extends TerraError {
  constructor() {
    super('Loyalty client id is not found');
  }
}

export class LoyaltyIamAudienceNotFoundError extends TerraError {
  constructor() {
    super('Not found IAM Audience for Loyalty');
  }
}

export class ProjectNotFoundError extends TerraError {
  constructor() {
    super('Not found Project');
  }
}
